module.exports = __webpack_public_path__ + "fr.svg?63f35221fabd1f8c9c1d54b30c10ab17";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/fr.svg
// module id = 1001
// module chunks = 27